import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const SwpPageContent = dynamic(() => import("components/Calculators/Swp"));

const SwpPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <SwpPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "SWP Calculator for MFDs | Plan Systematic Withdrawals | Wealthy",
    description:
      "Use Wealthy's SWP Calculator to estimate systematic withdrawal plans, compare payout strategies, and help clients plan retirement income with confidence.",
    keywords:
      "swp calculator, swp return calculator, best swp calculator, sip and swp calculator, swp mutual fund calculator, swp lumpsum calculator, sip with swp calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/swp`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "SWP Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/swp`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is an SWP Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "An SWP calculator is an online planning tool that estimates how regular withdrawals from a mutual fund investment may impact the remaining investment corpus over time. It helps distributors demonstrate projected withdrawals, investment growth and remaining corpus using assumed rates of return."
              }
            },
            {
              "@type": "Question",
              name: "How does an SWP Calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The SWP calculator considers the initial investment amount, expected annual return, withdrawal amount, withdrawal frequency and investment tenure to estimate how the investment may perform over time while systematic withdrawals are being made."
              }
            },
            {
              "@type": "Question",
              name: "Can clients choose the withdrawal amount?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. Investors can generally decide both the withdrawal amount and the withdrawal frequency, subject to the terms of the mutual fund scheme. These settings can usually be modified whenever financial requirements change."
              }
            },
            {
              "@type": "Question",
              name: "Is an SWP suitable only for retirees?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "No. While SWPs are commonly used for retirement planning, they can also be suitable for investors seeking regular income, managing recurring expenses or gradually withdrawing accumulated wealth."
              }
            },
            {
              "@type": "Question",
              name: "What happens if market returns are lower than expected?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "If investment returns remain below the withdrawal rate for an extended period, the investment corpus may reduce faster than anticipated. Regular portfolio reviews help distributors recommend suitable adjustments whenever required."
              }
            },
            {
              "@type": "Question",
              name: "Can I compare SIP and SWP strategies using Wealthy's calculators?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. Wealthy's SIP and SWP calculator ecosystem allows distributors to demonstrate both wealth accumulation and systematic withdrawal strategies, helping clients understand the complete investment lifecycle and make informed financial decisions."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default SwpPage;
